(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teacher-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function normalize(value) {
      return String(value || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase('en-GB')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function initialize(directory) {
      if (directory.dataset.pdReady === 'true') return;

      const instrument = directory.querySelector('[data-pd-instrument]');
      const county = directory.querySelector('[data-pd-county]');
      const cards = Array.from(
        directory.querySelectorAll('[data-pd-card]')
      );
      const results = directory.querySelector('[data-pd-results]');
      const noResults = directory.querySelector('[data-pd-no-results]');
      const filters = directory.querySelector('[data-pd-filters]');

      if (!instrument || !county || !results || !filters) return;

      directory.dataset.pdReady = 'true';
      filters.hidden = false;

      const records = cards.map((card) => {
        let instruments = [];

        try {
          const parsed = JSON.parse(card.dataset.instruments || '[]');
          if (Array.isArray(parsed)) instruments = parsed;
        } catch (error) {
          instruments = [];
        }

        return {
          card,
          instruments: instruments.map(normalize),
          location: normalize(card.dataset.location)
        };
      });

      function filterCards() {
        const selectedInstrument = normalize(instrument.value);
        const selectedCounty = normalize(county.value);
        let visible = 0;

        records.forEach((record) => {
          const instrumentMatches =
            !selectedInstrument ||
            record.instruments.includes(selectedInstrument);

          const countyMatches =
            !selectedCounty ||
            record.location.includes(selectedCounty);

          const matches = instrumentMatches && countyMatches;
          record.card.hidden = !matches;
          if (matches) visible += 1;
        });

        results.textContent =
          visible === 1
            ? '1 teacher shown'
            : `${visible} teachers shown`;

        if (noResults) {
          noResults.hidden = visible !== 0 || records.length === 0;
        }
      }

      instrument.addEventListener('change', filterCards);
      county.addEventListener('input', filterCards);
      filterCards();
    }

    function initializeWithin(root) {
      if (root instanceof Element && root.matches('.pd')) {
        initialize(root);
      }

      root.querySelectorAll('.pd').forEach(initialize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initializeWithin(document),
        { once: true }
      );
    } else {
      initializeWithin(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) {
        initializeWithin(event.target);
      }
    });

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const opener = event.target.closest('[data-pd-open]');

      if (opener) {
        const directory = opener.closest('.pd');
        const dialog = document.getElementById(opener.dataset.pdOpen);

        if (
          directory &&
          dialog instanceof HTMLDialogElement &&
          directory.contains(dialog) &&
          !dialog.open
        ) {
          dialog.showModal();
        }

        return;
      }

      const closer = event.target.closest('[data-pd-close]');

      if (closer) {
        const dialog = closer.closest('.pd__dialog');
        if (dialog instanceof HTMLDialogElement) dialog.close();
        return;
      }

      const dialog = event.target;

      if (
        dialog instanceof HTMLDialogElement &&
        dialog.classList.contains('pd__dialog')
      ) {
        const bounds = dialog.getBoundingClientRect();
        const outside =
          event.clientX < bounds.left ||
          event.clientX > bounds.right ||
          event.clientY < bounds.top ||
          event.clientY > bounds.bottom;

        if (outside) dialog.close();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
